import { Box, Icon, Text } from '@zillow/constellation-10';
import { IconExclamationCircleFilled } from '@zillow/constellation-icons';

const PropertyLookupError = () => (
  <Box css={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <Icon
      size="md"
      css={{ color: 'icon.feedback.critical.hero', marginRight: '400' }}
      render={<IconExclamationCircleFilled />}
      title="Error"
    />
    <Text
      textStyle="body-sm"
      asChild
      css={{ color: 'text.feedback.critical.strong', lineHeight: '18px', textAlign: 'center' }}
    >
      <p>There was an error with lookup. Please try again.</p>
    </Text>
  </Box>
);

export default PropertyLookupError;
